import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import App from './containers/App';
import Auth from './containers/auth/Auth'
import NotFoundPage from './containers/NotFoundPage.js';
import LoginPage from './containers/auth/LoginPage';
import Dashboard from './containers/DashboardPage';

import YosanPage from './containers/yosan/YosanPage';
import YosanHistoryPage from './containers/yosan/YosanHistoryPage';
import YosanListPage from './containers/yosan/YosanListPage';
import YosanHistoryListPage from './containers/yosan/YosanHistoryListPage';

import LeftDrawer from './components/LeftDrawer';

import Roumu from './containers/Roumu';


import CustomerMasterPage from './containers/master/customer/CustomerMasterPage';
import BranchOfficeMasterPage from './containers/master/branchOffice/BranchOfficeMasterPage';
import DepartmentMasterPage from './containers/master/department/DepartmentMasterPage';
import CostMasterPage from './containers/master/cost/CostMasterPage';
import WorkMasterPage from './containers/master/work/WorkMasterPage';
import UserMasterPage from './containers/master/user/UserMasterPage';
import PriceMasterPage from './containers/master/price/PriceMasterPage';
import KenmeiMasterPage from './containers/master/kenmei/KenmeiMasterPage';
import OverTimeMasterPage from './containers/master/overTime/OverTimeMasterPage';
import ConstructionMasterPage from './containers/master/construction/ConstructionMasterPage';

import BizHolidayMasterPage from './containers/master/bizHoliday/BizHolidayMasterPage';
import SubHolidayMasterPage from './containers/master/subHoliday/SubHolidayMasterPage';

import PasswordPage from './containers/master/password/PasswordPage';

import RoumuListPage from './containers/roumu/RoumuListPage';

import RoumuDownloadPage from './containers/roumu/RoumuDownloadPage';

import SystemControllMasterPage from './containers/master/systemControll/SystemControllMasterPage';
import SystemControllRoumuPage from './containers/master/systemControll/SystemControllRoumuPage';
import SystemControllAggregatePage from './containers/master/systemControll/SystemControllAggregatePage';
import RoumuControllMasterPage from './containers/master/roumuControll/RoumuControllMasterPage';
import SystemControllRoumuCsvPage from './containers/master/systemControll/SystemControllRoumuCsvPage';

const ContentsRouter = () => (
  <Router>
    <Switch>
      <App>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/yosan/:id" component={YosanPage} />
        <Route exact path="/yosanHistory/:id/:yearMonth" component={YosanHistoryPage} />
        <Route exact path="/yosan" component={YosanPage} />
        <Route exact path="/yosanList" component={YosanListPage} />
        <Route exact path="/yosanHistoryList" component={YosanHistoryListPage} />
        <Route exact path="/roumu/:userId/:approvalDate" component={Roumu} />
        <Route exact path="/roumu/:userId" component={Roumu} />
        <Route exact path="/roumu" component={Roumu} />
        <Route exact path="/roumuList" component={RoumuListPage} />
        <Route exact path="/timecard/:userId/:userName" component={RoumuDownloadPage} />
        <Route exact path="/timecard" component={RoumuDownloadPage} />
        <Route exact path="/master/customer" component={CustomerMasterPage} />
        <Route exact path="/master/branchOffice" component={BranchOfficeMasterPage} />
        <Route exact path="/master/department" component={DepartmentMasterPage} />
        <Route exact path="/master/cost" component={CostMasterPage} />
        <Route exact path="/master/work" component={WorkMasterPage} />
        <Route exact path="/master/user" component={UserMasterPage} />
        <Route exact path="/master/price" component={PriceMasterPage} />
        <Route exact path="/master/kenmei" component={KenmeiMasterPage} />
        <Route exact path="/master/construction" component={ConstructionMasterPage} />
        <Route exact path="/master/bizHoliday" component={BizHolidayMasterPage} />
        <Route exact path="/subHoliday/:userId/:userName" component={SubHolidayMasterPage} />
        <Route exact path="/subHoliday/:userId/:userName/:backDate" component={SubHolidayMasterPage} />
        <Route exact path="/subHoliday" component={SubHolidayMasterPage} />

        <Route exact path="/systemControll/subHoliday" component={SystemControllMasterPage} />
        <Route exact path="/systemControll/roumu" component={SystemControllRoumuPage} />
        <Route exact path="/systemControll/roumuCsv" component={SystemControllRoumuCsvPage} />
        <Route exact path="/systemControll/aggregate" component={SystemControllAggregatePage} />

        <Route exact path="/overTime" component={OverTimeMasterPage} />
        <Route exact path="/password" component={PasswordPage} />
        <Route exact path="/*" component={NotFoundPage} />
      </App>
    </Switch>
  </Router>
)

const AppRouter = () => (
  <Router>
    <Switch>
      <Route exact path="/login" component={LoginPage} />
      <Auth>
        <Route exact path="/*" component={ContentsRouter} />
      </Auth>
    </Switch>
  </Router>
)

export default AppRouter

// export default (
//   <Route>
//     <Route path="login" component={LoginPage}/>
//     <Route path="/" component={App}>
//       <IndexRoute component={Dashboard}/>
//       <Route path="dashboard" component={Dashboard}/>
//       <Route path="form" component={FormPage}/>
//       <Route path="table" component={TablePage}/>
//       <Route path="calendar" component={CalendarPage}/>
//       <Route path="*" component={NotFoundPage}/>
//     </Route>
//   </Route>
// );



// WEBPACK FOOTER //
// ./src/routes.js